<template lang="pug">
  #sign-in.mr-sign-in-v2.container.xs-f-small.max-at-tweak
    .row
      .xs-12.text-center
        .mr-sign-in-wrap.text-left
          template(v-if="view == 'signIn'")
            LoginSignUp

          template(v-if="view == 'createAccount'")
            CreateAccount(:show-birthday-input="showBirthdayInput")

          template(v-if="view == 'createPassword'")
            CreatePassword

          template(v-if="view == 'loginWithPassword'")
            LoginWithPassword

          template(v-if="view == 'loginWithPasskeys' && showPasskeys")
            LoginWithPasskeys
          template(v-else-if="view == 'loginWithPasskeys' && !showPasskeys")
            LoginWithPassword

          template(v-if="view == 'confirmationCreate'")
            SignUp(:confirmation-page="view == 'confirmationCreate'" :show-birthday-input="showBirthdayInput")

          template(v-if="view == 'verifyAccount'")
            VerifyAccount

          template(v-if="view == 'magicLinkSent'")
            MagicLinkSent

          template(v-if="view == 'loginWithMagicLink'")
            LoginWithMagicLink

          template(v-if="view == 'forgotPassword'")
            ForgotPassword

          template(v-if="view == 'resetPassword'")
            ResetPassword

          template(v-if="view == 'oneTimePassword'")
            SignIn2FA

          template(v-if="view == 'emailSent'")
            EmailSent(title="WE\'VE SENT you AN EMAIL" :just-sent="false" button-text="re-send email" @notification-emmited="onNotificationEmmited")

</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  import { defineAsyncComponent } from 'vue';
  import { verifyCipherStr } from "@services/vueCustomerSvc";

  import CreateAccount from '@components/MrSignInV2/CreateAccount';
  import CreatePassword from '@components/MrSignInV2/CreatePassword';
  import LoginSignUp from '@components/MrSignInV2/LoginSignUp';
  import LoginWithPassword from '@components/MrSignInV2/LoginWithPassword';
  import LoginWithPasskeys from '@components/MrSignInV2/LoginWithPasskeys';
  import VerifyAccount from '@components/MrSignInV2/VerifyAccount';
  import MagicLinkSent from '@components/MrSignInV2/MagicLinkSent';
  import LoginWithMagicLink from '@components/MrSignIn/LoginWithMagicLink';
  import ForgotPassword from '@components/MrSignInV2/ForgotPassword';
  import ResetPassword from '@components/MrSignInV2/ResetPassword';
  import SignIn2FA from '@components/MrSignIn/SignIn2FA';
  import EmailSent from '@components/MrSignIn/EmailSent';

  export default {
    name: "MrSignInV2",
    emits: ['notification-emmited'],

    components: {
      CreateAccount,
      CreatePassword,
      LoginSignUp,
      LoginWithPassword,
      LoginWithPasskeys,
      VerifyAccount,
      MagicLinkSent,
      LoginWithMagicLink,
      ForgotPassword,
      ResetPassword,
      SignIn2FA,
      EmailSent,
      SignUp: defineAsyncComponent(() => import(/* webpackChunkName: 'SignUpView' */'@components/MrSignIn/SignUp')),
    },

    inject: ['getObjProperty'],

    props: {
      next: {
        type: String,
        default: '',
      },
      startView: {
        type: String,
        default: '',
      },
      showBirthdayInput: {
        default: false,
        type: Boolean
      },
    },

    computed: {
      ...mapState('signIn', [
        'code',
        'view',
        'usePasskeys',
        'fidoData',
      ]),

      ...mapGetters('signIn', [
        'fidoRegistered',
      ]),

      ...mapState('global', [
        'isVueSSRApp',
        'urlParams'
      ]),

      ...mapState("systemSettings",['passkeysSettings']),
      ...mapState('global', ['windowData']),

      breakpoint() {
        return this.windowData.breakpoint;
      },

      showPasskeys() {
        return this.breakpoint == "mobile" && this.passkeysSettings?.enabled && this.usePasskeys && this.fidoRegistered;
      }
    },

    methods: {
      ...mapActions(['notifyError']),
      ...mapActions('systemSettings',['initPasskeysSettings']),

      ...mapMutations('signIn', [
        'setNextUrl',
        'setCode',
        'setUserEmail',
        'setView',
        'setOnSuccessCallback'
      ]),

      determineViewOnMount(urlParams) {
        let view;
        if (this.startView) {
          view = this.startView;
        } else if (urlParams && urlParams.view) {
          view = urlParams.view;
        }

        if (view) {
          this.setView(view);
        }
      },

      onNotificationEmmited(notification) {
        this.$emit('notification-emmited', notification);
      },
    },

    async mounted() {
      const urlParams = this.isVueSSRApp ? (this.urlParams || {}) : this.getObjProperty(this, '$root.urlParams') || {};

      await this.initPasskeysSettings();

      if (urlParams && urlParams.code) {
        this.setCode(decodeURIComponent(urlParams.code));
      }

      this.setNextUrl(decodeURIComponent(this.next || urlParams.next || window.location.pathname));

      this.determineViewOnMount(urlParams);

      const urlEmail = urlParams.email;

      if (urlEmail) {
        this.setUserEmail(decodeURIComponent(urlEmail));
        await this.checkHasPassword(urlEmail);
      }

      if (this.userEmail) {
        this.setUserEmail(this.userEmail);
      }

      if (this.code) {
        verifyCipherStr({ code: this.code }).then(res => {
          this.setUserEmail(res.data.email);
        }).catch(() => {
          this.notifyError("Invalid or expired password reset link.");
          this.setView('forgotPassword');
        });
      }
    },

    unmounted() {
      this.setView('signIn');
    }
  };
</script>

<style scoped lang="stylus">
  .mr-sign-in-v2
    .mr-sign-in-wrap
      display inline-block
      width 26em
      padding 3em 5%

    :deep(.sign-in-title)
      padding-bottom 0.2em

    :deep(.user-email)
      display inline-block
      max-width 20em
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      vertical-align top

    :deep(.change-email)
      display inline-block
      vertical-align top

    :deep(.please-allow)
    :deep(.resend-email)
      padding-right 20%

    :deep(.please-allow)
      padding-top 2.5em
      padding-bottom 0.5em

    @media mq-mobile
      .mr-sign-in-wrap
        width 100%

    @media mq-mobile-tweak-upper
      .mr-sign-in-wrap
        width 22em

    @media mq-desktop-md
      .mr-sign-in-wrap
        width 28em

    @media mq-desktop-plus
      .mr-sign-in-wrap
        width 29em

</style>
